import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../../constants/constants';

export const componentKey = "CHANGE_SCHEDULE_DATE_FOR_ALL_VENDAR";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },

        setScheduleDate: (state, action) => {
            state.scheduleDate = action.payload
        },

    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.PAGE_READY },

        scheduleDate: "",
    }
})

export const { setLoadingState, setScheduleDate } = actions; 